import { Route, Routes } from 'react-router-dom'

import MyBusiness from '../containers/config/MyBusiness'
import FreeAppContainer from '../containers/FreeAppContainer'
import ListAllProductsReadyForSale from '../containers/products/ListAllProductsReadyForSale'
import ListSalesCategories from '../containers/products/ListSalesCategories'
import StoreGalery from '../containers/store/StoreGalery'
import { HomePagePlanFree } from '../pages'
import NotFoundPage from '../pages/NotFoundPage'

const FreeRoute = () => {
  return (
    <Routes>
      <Route element={<FreeAppContainer />} path="/">
        {/**Home */}
        <Route element={<HomePagePlanFree link="inicio" />} index />
        {/**Stocks */}
        <Route element={<HomePagePlanFree link="stocks" />} path="/stocks" />
        <Route
          element={<HomePagePlanFree link="dispatches" />}
          path="/stocks/dispatches"
        />
        <Route
          element={<HomePagePlanFree link="stocks" />}
          path="/stocks/analysis"
        />
        {/**Products */}
        <Route
          element={<HomePagePlanFree link="products" />}
          path="/products/all"
        />
        <Route
          element={<ListAllProductsReadyForSale />}
          path="/products/sales"
        />
        <Route
          element={<ListSalesCategories />}
          path="/products/sales_categories"
        />
        <Route
          element={<HomePagePlanFree link="products" />}
          path="/products/general_categories"
        />
        {/**Ciclos económicos */}
        <Route
          element={<HomePagePlanFree link="ecocycle" />}
          path="/ecocycle"
        />
        {/**Usuarios */}
        <Route element={<HomePagePlanFree link="users" />} path="/users" />
        {/**Clientes */}
        <Route element={<HomePagePlanFree link="clients" />} path="/clients" />
        <Route element={<StoreGalery />} path="/store/galery" />
        <Route element={<MyBusiness />} path="/configurations/my_business" />
        <Route element={<NotFoundPage />} path="*" />
      </Route>
    </Routes>
  )
}

export default FreeRoute
